import React, { Component } from 'react';
import GoogleButton from 'components/GoogleButton';
import SignInForm from 'components/forms/Auth/SignInForm';
import withGoogleHandle from 'hocs/withGoogleHandle';
import { browserHistory } from 'react-router';
import '../style.css';

class SignIn extends Component {
  handleGoogle = () => {
    this.props.signUpWithGoogle({
      success: this.handleSignUpSuccess
    });
  }

  handleSignUp = () => {
    browserHistory.replace('/register');
  }

  handleSuccess = () => {
    browserHistory.replace('/');
  }

  render() {
    return (
      <div className="Account">
        <div className="auth-content text-center mx-auto">
          <h3 className="mt-4 mb-4">Welcome back!</h3>
          <GoogleButton
            text="Sign in with Google"
            onClick={this.handleGoogle}
            disabled={!this.props.gapiReady}
          />
          <p className="my-3">or</p>
          <SignInForm onSuccess={this.handleSuccess} />
          <div className="d-flex align-items-center justify-content-between my-4">
            <p className="my-0">Not a member yet?</p>
            <button
              type="button"
              className="btn btn-secondary btn-lg btn-cursor btn-rype-outline"
              onClick={this.handleSignUp}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withGoogleHandle(SignIn);



// WEBPACK FOOTER //
// ./src/pages/Account/SignIn/index.js